import { ActionType, useActionState } from '../../../status/state/actions.state';

import { Item } from '../../types/item.types';
import React from 'react';
import { StyledExpandedEndOfRowButton } from '../../../../shared/styles/components/integrations.styles';
import { SubItem } from '../../types/sub-item.types';
import editIcon from '@ingka/ssr-icon/paths/pencil';

type SingleEditButtonProps = {
   visible: boolean;
   rowData: SubItem;
   parentItem: Item;
};

export const SingleEditButton = ({ visible, rowData, parentItem }: SingleEditButtonProps) => {
   return visible ? (
      <StyledExpandedEndOfRowButton
         ssrIcon={editIcon}
         type={'tertiary'}
         iconOnly={true}
         small={true}
         onClick={() =>
            useActionState.setState({
               actionType: ActionType.editing,
               editRowData: rowData,
               parentItem: parentItem,
            })
         }
      />
   ) : (
      <></>
   );
};
